import Config from '@/config'

const { name, description } = Config.project

export default {
    general: {
        title: 'Welcome',
        titleTemplate: `%s | ${name}`,
        description,
    },
    home: {
        title: 'Home',
    },
}
